import axios from 'axios'
import { AppUrl } from '@/assets/js/variables'

const state = {
  email: {
    user: null,
    domain: null
  }
}

const getters = {

}

const actions = {
  getEmail ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'getEmail',
        payload: {}
      })
        .then(response => {
          if (response.data.payload) {
            commit('SET_email', { user: response.data.payload.user_part, domain: response.data.payload.domain_part })
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  },
  changeEmail ({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios.post(AppUrl, {
        task: 'changeEmail',
        payload: {
          user_part: filter.userPart,
          domain_part: filter.domainPart
        }
      })
        .then(response => {
          if (response.data.payload) {
            resolve(1)
          } else {
            resolve(0)
          }
        })
        .catch(error => {
          console.log(error)
        })
    })
  }
}

const mutations = {
  SET_email (state, data) {
    state.email.user = data.user
    state.email.domain = data.domain
  },
  COMMIT_emailUser (state, data) {
    state.email.user = data
  },
  COMMIT_emailDomain (state, data) {
    state.email.domain = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/profileSettings.js